<template>
    <router-view />
</template>

<script>
export default {
    name: 'ServiceConfigContainer'
};
</script>
